import React from "react";
import PropTypes from "prop-types";
import { Typography, makeStyles } from "@material-ui/core";

import { TextValidator } from "react-material-ui-form-validator";

const styles = makeStyles((theme) => ({
  wrapper: {
    marginTop: 16,
    marginBottom: 16,
  },
  label: {
    fontSize: 14,
    fontWeight: 600
  },
  textbox: {
    marginTop: 8
  }
}));

function LabeledTextValidator(props) {
  let classes = styles(),
    { label, ...rest } = props;

  return (
    <div className={classes.wrapper}>
      <Typography className={classes.label}>{label}</Typography>
      <TextValidator className={classes.textbox} {...rest} />
    </div>
  );
}

LabeledTextValidator.propTypes = {
  label: PropTypes.string,
};

export default LabeledTextValidator;
